import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
const t = {
  name: e.swedish,
  global: {
    undo: "Ångra",
    redo: "Klar",
    confirm: "Bekräfta",
    clear: "Klar",
    more: "mer",
    cancel: "Avbryta"
  },
  Popconfirm: {
    positiveText: "Bekräfta",
    negativeText: "Avbryt"
  },
  Cascader: {
    placeholder: "Vänligen välj",
    loading: "Laddar",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Klar",
    now: "Nu",
    confirm: "Bekräfta",
    selectTime: "Välj tidpunkt",
    selectDate: "Välj datum",
    datePlaceholder: "Välj datum",
    datetimePlaceholder: "Välj datum och tid",
    monthPlaceholder: "Välj månad",
    yearPlaceholder: "Välj år",
    quarterPlaceholder: "Välj kvartal",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Slutdatum",
    startDatetimePlaceholder: "Startdatum och tid",
    endDatetimePlaceholder: "Slutdatum och tidpunkt",
    startMonthPlaceholder: "Startmånad",
    endMonthPlaceholder: "Slutet av månaden",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Idag"
  },
  DataTable: {
    checkTableAll: "Välj allt i tabellen",
    uncheckTableAll: "Avmarkera allt i tabellen",
    confirm: "Bekräfta",
    clear: "Klar",
    apply: "Ansök",
    filters: "Filter",
    sort: "Sortera"
  },
  LegacyTransfer: {
    sourceTitle: "Källa",
    targetTitle: "Mål"
  },
  Transfer: {
    selectAll: "Markera alla",
    unselectAll: "Avmarkera alla",
    clearAll: "Tydlig"
  },
  Empty: {
    description: "Inget data"
  },
  Select: {
    placeholder: "Välj"
  },
  TimePicker: {
    placeholder: "Välj tid",
    positiveText: "OK",
    negativeText: "Avbryt",
    now: "Nu"
  },
  Pagination: {
    goto: "Gå till",
    selectionSuffix: "sida",
    next: "Nästa",
    previous: "Föregående"
  },
  DynamicTags: {
    add: "Lägg till"
  },
  Log: {
    loading: "Läser in"
  },
  Input: {
    placeholder: "Vänligen ange"
  },
  InputNumber: {
    placeholder: "Var vänlig ange"
  },
  DynamicInput: {
    create: "Skapa"
  },
  ThemeEditor: {
    title: "Teman Redigerare",
    clearAllVars: "Rensa alla variabler",
    clearSearch: "Rensa sökning",
    filterCompName: "Filterkomponentnamn",
    filterVarName: "Filter Variabelnamn",
    import: "Importera",
    export: "Export",
    restore: "Återställ till standardinställningar"
  },
  Image: {
    tipPrevious: "Föregående bild (←)",
    tipNext: "Nästa bild (→)",
    tipCounterclockwise: "Moturs",
    tipClockwise: "Medurs",
    tipZoomOut: "Zooma ut",
    tipZoomIn: "Zooma in",
    tipClose: "Stäng (Esc)",
    tipOriginalSize: "Zooma till originalstorlek"
  },
  SortFilter: {
    heading: "Sortera och filtrera",
    sortHeading: "Sortera efter",
    newestFirst: "Nyast först",
    oldestFirst: "Äldst först",
    ascending: "Stigande",
    descending: "Fallande",
    aToZ: "A-Ö",
    zToA: "Ö-A",
    apply: "Använd",
    clear: "Rensa",
    cancel: "Avbryt",
    filters: "Filter"
  },
  IconPicker: {
    noMatchingFound: "Inga matchande resultat hittades"
  },
  Spacing: {
    margin: "Marginal",
    padding: "Stoppning",
    reset: "Återställa",
    errorMsg: "Det angivna värdet är ogiltigt."
  },
  BrandColorPicker: {
    brandColors: "Varumärkesfärger",
    noBrandColors: "Du har inte lagt till några varumärkesfärger än.",
    getStarted: "Kom igång",
    add: "Lägg till",
    default: "Standard"
  }
};
export {
  t as sv
};
